import joi from 'joi'

const numberPattern = /^[0]{1}([7-9]{1}[0]{1}|[8]{1}[1]{1})\d{8}$/i

interface signupType {
  first_name: string
  last_name: string
  email: string
  phone_number: string | number
  password: string
  referred_by?: string | number
}
interface signupFirstType {
  first_name: string
  last_name: string
  email: string
  phone_number: string | number
  referred_by?: any
}

interface passwordTypes {
  password: string
}

interface EmailTypes {
  email: string
}

interface phoneTypes {
  phone_number: string | number
}

interface signInTypes {
  email: string
  password: string
}

export const validateSignIn = (data: signInTypes) => {
  const signInSchema = joi.object({
    email: joi
      .string()
      .required()
      .email({ tlds: { allow: false } }),
    password: joi.string().min(2),
  })

  return signInSchema.validate(data)
}

export const validateSignup = (data: signupType) => {
  const signupSchema = joi.object({
    first_name: joi.string().required(),
    last_name: joi.string().required(),
    email: joi
      .string()
      .required()
      .email({ tlds: { allow: false } }),
    phone_number: joi.string().required().regex(numberPattern),
    password: joi.string().min(6),
    referred_by: joi.any(),
  })
  return signupSchema.validate(data)
}

export const validateFirstSignup = (data: signupFirstType) => {
  const signupFirstSchema = joi.object({
    first_name: joi.string().required(),
    last_name: joi.string().required(),
    email: joi
      .string()
      .required()
      .email({ tlds: { allow: false } }),
    phone_number: joi.string().required(),
    referred_by: joi.any(),
  })
  return signupFirstSchema.validate(data)
}

export const validatePassword = (data: passwordTypes) => {
  const resetSchema = joi.object({
    password: joi.string().required().min(6),
  })
  return resetSchema.validate(data)
}

export const validateEmail = (data: EmailTypes) => {
  const emailSchema = joi.object({
    email: joi
      .string()
      .required()
      .email({ tlds: { allow: false } }),
  })
  return emailSchema.validate(data)
}

export const validatePhoneNumber = (data: phoneTypes) => {
  const phoneSchema = joi.object({
    phone_number: joi.string().required().regex(numberPattern),
  })

  return phoneSchema.validate(data)
}
